/**
 * @generated SignedSource<<4de8f72023637df0c2b9aa01942f44e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paletteColorsPage_colorsQuery$variables = {
  after?: string | null;
  first?: number | null;
  id?: string | null;
  orderBy?: string | null;
  search?: string | null;
  useConversionTable?: boolean | null;
};
export type paletteColorsPage_colorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"paletteColorsPage_colors">;
};
export type paletteColorsPage_colorsQuery = {
  response: paletteColorsPage_colorsQuery$data;
  variables: paletteColorsPage_colorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useConversionTable"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "useConversionTable",
    "variableName": "useConversionTable"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "paletteColorsPage_colorsQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "FragmentSpread",
        "name": "paletteColorsPage_colors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "paletteColorsPage_colorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "PaletteColorsConnection",
        "kind": "LinkedField",
        "name": "paletteColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaletteColor",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "colorID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rgbHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cmykHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotColorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "filters": [
          "search",
          "id",
          "orderBy",
          "useConversionTable"
        ],
        "handle": "connection",
        "key": "colors_paletteColors",
        "kind": "LinkedHandle",
        "name": "paletteColors"
      }
    ]
  },
  "params": {
    "cacheID": "1fbf7a5778b585036d99b4ac6800cc0c",
    "id": null,
    "metadata": {},
    "name": "paletteColorsPage_colorsQuery",
    "operationKind": "query",
    "text": "query paletteColorsPage_colorsQuery(\n  $first: Int\n  $after: String\n  $search: String\n  $id: String\n  $orderBy: String\n  $useConversionTable: Boolean\n) {\n  ...paletteColorsPage_colors_2a5uHn\n}\n\nfragment paletteColorsPage_colors_2a5uHn on Query {\n  paletteColors(first: $first, after: $after, search: $search, id: $id, orderBy: $orderBy, useConversionTable: $useConversionTable) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        colorID\n        name\n        rgbHexCode\n        cmykHexCode\n        spotColorName\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b716b5239e71d0a286ab69e28c38cf4";

export default node;
